module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/1/1-9f90f240b60de45b8785104e10392862.jpg";